import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {DiscountsActions} from '../store';
import {DiscountsSelectors} from '../store/selectors';

@Injectable()
export class DiscountsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadDiscountsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadDiscountsDone() {

    return this.store.pipe(
      select(DiscountsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(DiscountsActions.ReadDiscounts());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
